import React, { Fragment } from 'react';
import classes from '../Nps.module.css';
import { Grid } from '@material-ui/core';
import NumberFormat from 'react-number-format';

const NpsScore = props => {
	const { data } = props;

	let scoreNps;
	let score9y10;
	let score7y8;
	let score6;
	let n9y10;
	let n7y8;
	let n6;

	const arrayn9y10 = [];
	const arrayn7y8 = [];
	const arrayn6 = [];

	var last = function(data, n) {
		if (data == null) return void 0;
		if (n == null) return data[data.length - 1];
		return data.slice(Math.max(data.length - n, 0));
	};

	if (last(data)) {
		data.forEach(element => {
			arrayn9y10.push(element.n9y10);
			n9y10 = arrayn9y10.reduce((partialSum, a) => partialSum + a, 0);

			arrayn7y8.push(element.n7y8);
			n7y8 = arrayn7y8.reduce((partialSum, a) => partialSum + a, 0);

			arrayn6.push(element.n6);
			n6 = arrayn6.reduce((partialSum, a) => partialSum + a, 0);
		});

		scoreNps = ((n9y10 - n6) / (n9y10 + n7y8 + n6)) * 100;
		score9y10 = (n9y10 / (n9y10 + n7y8 + n6)) * 100;
		score7y8 = (n7y8 / (n9y10 + n7y8 + n6)) * 100;
		score6 = (n6 / (n9y10 + n7y8 + n6)) * 100;
	}

	return (
		<Fragment>
			<Grid item xs={4}>
				<div className={classes.npsScoreCard}>
					<div className={classes.npsTitle}>NPS Score Actual</div>
					<div className={classes.npsScore}>
						<NumberFormat value={scoreNps} displayType={'text'} thousandSeparator={true} decimalScale={0} />
					</div>
				</div>
				<Grid container spacing={1}>
					<Grid item xs={4}>
						<div className={classes.npsRed}>
							<NumberFormat value={score6} displayType={'text'} thousandSeparator={true} decimalScale={1} suffix={'%'} />
							<br></br>
							<NumberFormat value={n6} displayType={'text'} thousandSeparator={true} decimalScale={1} />
						</div>
					</Grid>
					<Grid item xs={4}>
						<div className={classes.npsYellow}>
							<NumberFormat value={score7y8} displayType={'text'} thousandSeparator={true} decimalScale={1} suffix={'%'} />
							<br></br>
							<NumberFormat value={n7y8} displayType={'text'} thousandSeparator={true} decimalScale={1} />
						</div>
					</Grid>
					<Grid item xs={4}>
						<div className={classes.npsGreen}>
							<NumberFormat value={score9y10} displayType={'text'} thousandSeparator={true} decimalScale={1} suffix={'%'} />
							<br></br>
							<NumberFormat value={n9y10} displayType={'text'} thousandSeparator={true} decimalScale={1} />
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	);
};

export default React.memo(NpsScore);
